var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdatedAt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1452_854)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.9751,
    cy: 18,
    r: 16,
    fill: "#FCF1FA"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9751,
    cy: 18,
    r: 7,
    fill: "#E471D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9762 14.3664V17.9996H21.7011M24.426 17.9996C24.426 18.7153 24.2851 19.424 24.0112 20.0852C23.7373 20.7464 23.3359 21.3472 22.8298 21.8532C22.3237 22.3593 21.723 22.7607 21.0618 23.0346C20.4006 23.3085 19.6919 23.4495 18.9762 23.4495C18.2605 23.4495 17.5518 23.3085 16.8906 23.0346C16.2294 22.7607 15.6286 22.3593 15.1226 21.8532C14.6165 21.3472 14.2151 20.7464 13.9412 20.0852C13.6673 19.424 13.5264 18.7153 13.5264 17.9996C13.5264 16.5542 14.1005 15.1681 15.1226 14.146C16.1446 13.124 17.5308 12.5498 18.9762 12.5498C20.4216 12.5498 21.8078 13.124 22.8298 14.146C23.8518 15.1681 24.426 16.5542 24.426 17.9996Z",
    stroke: "#FCF1FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1452_854",
    x: 0.975098,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.443137 0 0 0 0 0.819608 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1452_854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1452_854",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedAt);
export default __webpack_public_path__ + "static/media/updated-at.4a5ac035f745501ac123697c03bf8b99.svg";
export { ForwardRef as ReactComponent };